import { render, staticRenderFns } from "./componentGradebookModal.vue?vue&type=template&id=7b615de7&scoped=true"
import script from "./componentGradebookModal.vue?vue&type=script&lang=js"
export * from "./componentGradebookModal.vue?vue&type=script&lang=js"
import style0 from "./componentGradebookModal.vue?vue&type=style&index=0&id=7b615de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b615de7",
  null
  
)

export default component.exports